module.exports = __webpack_public_path__ + "img/10.fe4190af.png";